import { FooterBrand, FooterLinks, FooterReach } from "./FooterParts";

export default function Footer() {
  return (
    <footer className="relative border-t border-line bg-ink pb-28 md:pb-0" data-testid="footer-section">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <p
          className="pointer-events-none select-none font-display text-[16vw] font-black uppercase leading-none text-white/[0.04] lg:text-[10rem]"
          aria-hidden="true"
        >
          Lift Edge
        </p>

        <div className="mt-4 grid gap-12 border-t border-line pt-12 md:grid-cols-3">
          <FooterBrand />
          <FooterLinks />
          <FooterReach />
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-line pt-7">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
            © 2026 Lift Edge Hercules Fitness Store · Siliguri, West Bengal
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
            Power Your Fitness. Built to Perform.
          </p>
        </div>
      </div>
    </footer>
  );
}
